package com.devi3east.bashbuddy.di

import com.devi3east.bashbuddy.auth.data.api.AuthApi
import com.devi3east.bashbuddy.auth.data.repositories.AuthRepositoryImpl
import com.devi3east.bashbuddy.auth.domain.repositories.AuthRepository
import com.devi3east.bashbuddy.cart.data.api.CartApi
import com.devi3east.bashbuddy.cart.data.repositories.CartRepositoryImpl
import com.devi3east.bashbuddy.cart.domain.repositories.CartRepository
import com.devi3east.bashbuddy.common.service.AppConfigApi
import com.devi3east.bashbuddy.common.service.AppConfigRepository
import com.devi3east.bashbuddy.common.service.AppConfigRepositoryImpl
import com.devi3east.bashbuddy.features.common.data.api.BASE_URL
import com.devi3east.bashbuddy.dashboard.data.api.DashboardApi
import com.devi3east.bashbuddy.dashboard.data.repositories.DashboardRepositoryImpl
import com.devi3east.bashbuddy.dashboard.domain.DashboardRepository
import com.devi3east.bashbuddy.features.detail.data.datasources.RecipeDetailLocalDataSource
import com.devi3east.bashbuddy.features.detail.data.datasources.RecipeDetailLocalDataSourceImpl
import com.devi3east.bashbuddy.features.detail.data.datasources.RecipeDetailRemoteDataSource
import com.devi3east.bashbuddy.features.detail.data.datasources.RecipeDetailRemoteDataSourceImpl
import com.devi3east.bashbuddy.features.detail.data.repositories.RecipeDetailRepositoryImpl
import com.devi3east.bashbuddy.features.detail.repositories.RecipeDetailRepository
import com.devi3east.bashbuddy.features.events.common.EventRepository
import com.devi3east.bashbuddy.features.events.common.EventRepositoryImpl
import com.devi3east.bashbuddy.features.events.common.data.api.EventApi
import com.devi3east.bashbuddy.ktor.stripe.data.api.StripeApi
import com.devi3east.bashbuddy.ktor.stripe.data.repositories.StripeRepositoryImpl
import com.devi3east.bashbuddy.ktor.stripe.domain.StripeRepository
import com.devi3east.bashbuddy.preferences.AppPreferences
import com.devi3east.bashbuddy.preferences.AppPreferencesImpl
import com.russhwolf.settings.Settings
import org.koin.dsl.module

fun dataModule()  = module {

    single<Settings> { Settings() }
    single<AppPreferences> { AppPreferencesImpl(get()) }

    single { AuthApi(get(), BASE_URL) }
    single { EventApi(get(), BASE_URL) }
    single { DashboardApi(get(), BASE_URL) }
    single { CartApi(get(), BASE_URL)}
    single { StripeApi(get(), BASE_URL)}
    single { AppConfigApi(get(), BASE_URL)}

    single<AuthRepository> { AuthRepositoryImpl(get(), get()) }
    single<EventRepository> { EventRepositoryImpl(get())}
    single<StripeRepository> { StripeRepositoryImpl(get()) }
    single<DashboardRepository> { DashboardRepositoryImpl(get()) }
    single<CartRepository> { CartRepositoryImpl(get()) }
    single<AppConfigRepository> {AppConfigRepositoryImpl(get())}


    single<RecipeDetailLocalDataSource> { RecipeDetailLocalDataSourceImpl(get(), get()) }
    single<RecipeDetailRemoteDataSource> { RecipeDetailRemoteDataSourceImpl(get()) }
    single<RecipeDetailRepository> { RecipeDetailRepositoryImpl(get(), get()) }

}